<div class="bg-white rounded-xl p-2 flex justify-between items-start gap-2">
  <!-- IZQUIERDA: Imagen + info -->
  <div class="flex items-start gap-3 flex-1 min-w-0">
    <!-- Imagen del producto -->
    <div class="w-20 h-20 flex-shrink-0 flex items-center justify-center">
      <img
        [src]="imageUrl || 'assets/images/no-image.png'"
        alt="{{ productName }}"
        class="max-w-full max-h-full object-contain rounded-lg"
        (error)="onImageError($event)"
      />
    </div>

    <!-- Nombre y año -->
    <div class="flex flex-col justify-between min-w-0 pr-2">
      <span class="text-metro-black break-words">{{ productName }}</span>
      <span class="text-xs text-metro-blue">{{ year }}, {{country}}</span>
      <!-- Mensaje de stock máximo alcanzado -->
      @if (isAtMaxStock) {
        <span class="text-xs text-red-500">{{ '::NoMoreStockAvailable' | abpLocalization }}</span>
      }
    </div>
  </div>

  <!-- DERECHA: Cantidad + Precio -->
  <div class="flex flex-col items-end gap-1 flex-shrink-0">
    <div class="flex items-center border rounded-md overflow-hidden">
      <button
        class="px-1 py-1 bg-metro-blue text-metro-secondary"
        [disabled]="isLoading || items <= 1"
        [class.opacity-50]="isLoading || items <= 1"
        (click)="decrement()">-
      </button>
      <span class="px-2 py-1">{{ items }}</span>
      <button
        class="px-1 py-1 bg-metro-blue  text-metro-secondary"
        [disabled]="isLoading"
        [class.opacity-50]="isLoading"
        (click)="increment()">+
      </button>
    </div>

    <!-- Precio -->
    <span class="text-metro-blue-secondary font-semibold ">$ {{ price * items | number:'1.0-0'}}</span>

    <!-- Botón de eliminar -->
    @if (showDeleteButton) {
      <button
        type="button"
        class="text-red-500 hover:text-red-700 text-sm font-medium ml-2"
        [disabled]="isLoading"
        [class.opacity-50]="isLoading"
        (click)="deleteItemFromCart()"
        title="{{ '::DeleteItem' | abpLocalization }}">
        {{ '::Delete' | abpLocalization }}
      </button>
    }
  </div>
</div>
